// key ของกรอบผูกกับ vehicle id ห้ามใช้ index — ไม่งั้นกล้อง/ความคมชัดที่เลือกและสถานะเสียงติดข้ามไปคันใหม่

import React from 'react'
import PropTypes from 'prop-types'
import { MODE } from '../lib/constants'
import { API_READY } from '../lib/livestreamApi'
import { Grid } from '../styles/wall'
import VideoCell from './VideoCell'

// ยิงตรงเฉพาะรถที่พร้อมตาม TOR 2026 · คันอื่น (หรือยังไม่ได้ตั้ง endpoint) เปิดลิงก์เดิมใน iframe
function modeOf(vehicle) {
  return API_READY && vehicle && vehicle.is_tor2026_ready === 1
    ? MODE.DIRECT
    : MODE.IFRAME
}

export default function VideoWall({
  slots,
  layout,
  height,
  selectedId,
  txt,
  onSelect,
  onRemove,
}) {
  const cols = Math.sqrt(layout)

  return (
    <Grid cols={cols} height={height}>
      {slots.map((vehicle, index) => (
        <VideoCell
          key={vehicle ? `v-${vehicle.id}` : `empty-${index}`}
          vehicle={vehicle}
          slotIndex={index}
          mode={modeOf(vehicle)}
          selected={!!vehicle && vehicle.id === selectedId}
          txt={txt}
          onSelect={() => vehicle && onSelect(vehicle.id)}
          onRemove={() => vehicle && onRemove(vehicle.id)}
        />
      ))}
    </Grid>
  )
}

VideoWall.propTypes = {
  /** ยาวเท่า layout เสมอ ช่องที่ยังไม่มีรถเป็น null */
  slots: PropTypes.array.isRequired,
  layout: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  selectedId: PropTypes.number,
  txt: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
}
